export { default } from './Slider';
export * from './modes';